import { gql } from "@apollo/client";
import { permitDetailFragment, PermitDetailRaw } from "../fragments";

/**
 * Mutation to submit a permit application.
 *
 * Note: The actual mutation definition should be provided by the backend team.
 * This is a placeholder that defines the expected input/output types.
 */
export const SUBMIT_PERMIT_APPLICATION = gql`
  mutation SubmitPermitApplication(
    $permitTypeId: uuid!
    $assignedVehicleIds: [uuid!]
    $attachedDocuments: [permit_attached_document!]
    $termsAndConditionsAcceptedAt: timestamptz!
  ) {
    submitPermitApplication: submit_permit_application(
      permit_type_id: $permitTypeId
      assigned_vehicle_ids: $assignedVehicleIds
      attached_documents: $attachedDocuments
      terms_and_conditions_accepted_at: $termsAndConditionsAcceptedAt
    ) {
      permit {
        ...permitDetailFragment
      }
    }
  }
  ${permitDetailFragment}
`;

/**
 * Input for attaching a document to the permit application
 */
export interface PermitAttachedDocument {
  /** The document type ID */
  document_type_id: string;
  /** The uploaded document ID */
  document_id: string;
}

/**
 * Input variables for the SubmitPermitApplication mutation
 */
export interface SubmitPermitApplicationVars {
  /** The permit type being applied for */
  permitTypeId: string;
  /** Vehicle IDs to assign to the permit */
  assignedVehicleIds?: string[];
  /** Documents attached to the application */
  attachedDocuments?: PermitAttachedDocument[];
  /** ISO timestamp when terms and conditions were accepted */
  termsAndConditionsAcceptedAt: string;
}

/**
 * Data returned by the SubmitPermitApplication mutation
 */
export interface SubmitPermitApplicationData {
  submitPermitApplication: {
    permit: PermitDetailRaw;
  };
}

export default SUBMIT_PERMIT_APPLICATION;
